import "./src/style/app.scss"
import React from "react"
import AppProvider from "./wrap-with-provider"

export const wrapRootElement = ({ element }) => {
  return <AppProvider element={element} />
}
